import { useState } from 'react'
import { track } from '@vercel/analytics'

export default function WelcomeBanner({ isAtPOI, onDismiss, loadingComplete }) {
  const [dismissed, setDismissed] = useState(false)

  const handleDismiss = () => {
    setDismissed(true)
    onDismiss()
  }

  if (!loadingComplete || dismissed || isAtPOI) return null

  return (
    <div className="welcome-banner-overlay" onClick={() => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ event: 'button_click', poi_label: 'Welcome - Dismiss' })
      track('button_click', { poi_label: 'Welcome - Dismiss' })
      handleDismiss()
    }}>
      <div className="welcome-banner" onClick={e => e.stopPropagation()}>
        <button
          className="welcome-banner-close"
          onClick={() => {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({ event: 'button_click', poi_label: 'Welcome - Close' })
            track('button_click', { poi_label: 'Welcome - Close' })
            handleDismiss()
          }}
          aria-label="Close"
        >
          X
        </button>
        <h2 className="welcome-banner-title">
          Welcome to the Lamba Ness Launch Site!
        </h2>
        <p className="welcome-banner-body">
          Situated at SaxaVord Spaceport on Unst, the UK's northernmost island,
          this interactive experience invites you to explore our facilities, discover
          our history, and see how the future of UK rocket launch is taking shape.
        </p>
        <p className="welcome-banner-body">
          The majority of our site is already operational and ready for launch. This
          model shows Launch Pads 2 and 3 as they will appear once construction is
          finished.
        </p>
        <button
          className="welcome-banner-button"
          onClick={() => {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({ event: 'button_click', poi_label: 'Welcome - Explore' })
            track('button_click', { poi_label: 'Welcome - Explore' })
            handleDismiss()
          }}
        >
          EXPLORE
        </button>
      </div>
    </div>
  )
}
